import React from 'react';
import { Segment, Button, Icon, Menu } from 'semantic-ui-react';
import Toggleable from '../../../darkmatter/Toggleable';
import MenuItems from './MenuItems';

export default ({
  logo,
  position,
  links,
  linksAs,
  className,
  centerMobileNavItems,
  backgroundColor,
  invertedHamburgerButton,
}) => (
  <Segment className={className} style={{ backgroundColor }}>
    <Toggleable>
      {(toggle, onToggle) => (
        <React.Fragment>
          <div className="mobile-nav-header">
            <Button onClick={onToggle} style={{ float: position === 'left' ? 'right' : 'left' }}>
              <Icon
                inverted={invertedHamburgerButton}
                name="bars"
                size="large"
                color="primary"
                style={{ margin: '0 auto', height: 'unset' }}
              />
            </Button>
            <div>{logo}</div>
          </div>
          {toggle && (
            <Menu vertical className="mobile-nav-menu">
              <MenuItems links={links} linksAs={linksAs} />
            </Menu>
          )}
        </React.Fragment>
      )}
    </Toggleable>
  </Segment>
);
